/**
 * PhaseEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { VisitTypeEntity } from "../VisitTypeEntity";
import { Phase_BugGroupsEntity } from "../Phase_BugGroupsEntity";
import { VisitEntity } from "../VisitEntity";
import { BugEntity } from "../BugEntity";
import { BugNoteEntity } from "../BugNoteEntity";
import { PhaseEntity } from "../PhaseEntity";
declare global {
    interface EntityTypeMap {
        Phase: PhaseEntity;
    }
}
export abstract class PhaseGeneratedEntity extends BaseEntity {
    public abstract phaseId: string;
    public abstract templateId: string | null;
    public abstract index: number | null;
    public abstract name: string | null;
    public abstract externalId: string | null;
    public abstract nameSystem: string | null;
    public abstract validDurationAfterHandover: number | null;
    public abstract nameComputed: string;
    public abstract project: ProjectEntity;
    public abstract readonly visitTypes: ReadonlyArray<VisitTypeEntity>;
    public abstract readonly bugGroupsRelations: ReadonlyArray<Phase_BugGroupsEntity>;
    public abstract readonly visits: ReadonlyArray<VisitEntity>;
    public abstract readonly bugs: ReadonlyArray<BugEntity>;
    public abstract readonly bugNotes: ReadonlyArray<BugNoteEntity>;
}
